import { render, staticRenderFns } from "./PhoneComponentGlobal.vue?vue&type=template&id=5cbceb5e&scoped=true&"
import script from "./PhoneComponentGlobal.vue?vue&type=script&lang=js&"
export * from "./PhoneComponentGlobal.vue?vue&type=script&lang=js&"
import style0 from "./PhoneComponentGlobal.vue?vue&type=style&index=0&id=5cbceb5e&scoped=true&lang=css&"
import style1 from "./PhoneComponentGlobal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbceb5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VSelect,VTextField})
